<template>
    <div>
        <b-container>
            <b-row><b-col>
                <h4>{{ $t('traffic_deviations.canceled_departures.trips') }}</h4>
            </b-col></b-row>
            <b-row>
                <b-col>{{ selectedBlockSequenceData.blockLabel }}</b-col>
                <b-col>{{ selectedBlockSequenceData.time }}</b-col>
                <b-col>{{ selectedBlockSequenceData.vehicleLabel }}</b-col>
            </b-row>
            <b-row><b-col>
                <b-form-checkbox-group
                id="cb-trip-canceled"
                name="cb-trip-canceled"
                v-model="tripsWithCancellations">
                <b-table
                    ref="tripstable"
                    :fields="tripsListFields"
                    :items="tripsListItems"
                    selectable
                    select-mode="single"
                    @row-selected="onSelectTrip">
                    <template #head(passingsCanceled)="data">
                        <input type="checkbox" :id="'cb-'+ data.label.toLowerCase() +'-all-trips'" v-model="selectAllTrips" />
                    </template>
                    <template v-slot:cell(passingsCanceled)="data">
                        <b-form-checkbox :value="data.item.tripId"></b-form-checkbox>
                    </template>
                </b-table>
                </b-form-checkbox-group>
            </b-col></b-row>
        </b-container>
    </div>
</template>

<script>
import moment from 'moment';
import { getPassingKey, isPassingCanceled } from '@/store/dispatching/trafficDeviations.js';

export default {
    name: 'TripsTable',
    data() {
        return {
            tripsWithCancellations: [],
            selectAllTrips: false,
            newTripsListInitialSelections: true
        };
    },
   computed: {
        tripsListFields() {
            let fields = [
                { key: 'passingsCanceled', label: this.$t('traffic_deviations.canceled_departures.canceled'), sortable: false },
                { key: 'lineNumber', label: this.$t('traffic_deviations.canceled_departures.line'), sortable: false },
                { key: 'destination', label: this.$t('traffic_deviations.canceled_departures.destination'), sortable: false },
                { key: 'departureTime', label: this.$t('traffic_deviations.canceled_departures.time'), sortable: false, formatter: (value, key, item) => {
                    let result = '';
                    if (Array.isArray(item.passings) && item.passings.length > 0) {
                        let start = moment.parseZone(item.passings[0].departureTime);
                        if (start.isValid()) {
                            result = start.format('HH:mm');

                            let lastPassing = item.passings[item.passings.length - 1];
                            let end = moment.parseZone(lastPassing.passingTime);
                            if (end.isValid()) {
                                result += '\xa0- '+ end.format('HH:mm');
                            }
                        }
                    }
                    if (result.length > 0)
                        return result;

                    let time = moment.parseZone(value);
                    if (time.isValid()) {
                        return time.format('HH:mm');
                    }
                    return value;
                }}
            ];
            if (this.$UiConfig('/ui/view/dispatching/canceleddepartures/showTripId', false))
                fields.splice(3, 0, { key: 'tripId', label: this.$t('traffic_deviations.canceled_departures.trip'), sortable: false });

            return fields;
        },
        tripsListItems() {
            let selectedBlockSequence = this.$store.state.trafficDeviations.selectedBlockSequence;
            if (!selectedBlockSequence)
                return [];

            return this.$store.state.trafficDeviations.tripsByBlockSequence[selectedBlockSequence.blockSequenceId];
        },
        selectedBlockSequenceId() {
            if (this.$store.state.trafficDeviations.selectedBlockSequence)
                return this.$store.state.trafficDeviations.selectedBlockSequence.blockSequenceId;

            return '';
        },
        selectedBlockSequenceData() {
            let blockSequence = this.$store.state.trafficDeviations.selectedBlockSequence;
            if (!blockSequence || !blockSequence.blockSequenceId)
                return { blockLabel: '', time: '', vehicleLabel: '' };

            return {
                blockLabel: blockSequence.blockLabel,
                time: this.getTimeFromTimestamp(blockSequence.startTime) + '\xa0- ' + this.getTimeFromTimestamp(blockSequence.endTime),
                vehicleLabel: blockSequence.vehicleLabel
            }
        }
   },
   watch: {
        selectedBlockSequenceId(newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                this.$store.dispatch('trafficDeviations/getTripsByBlockSequenceAndDate', {
                    blockSequenceId: newVal,
                    date: this.$store.state.trafficDeviations.selectedDate
                }).then(response => this.autoSelectTrip(response.data));
            }
        },
        tripsListItems(tripsList) {
            let canceled = [];
            if (Array.isArray(tripsList)) {
                for (const trip of tripsList) {
                    if ((trip.passingsCanceled == 'true' && !this.isAllCancellationsRemoved(trip)) ||
                            this.isCancellationAdded(trip))  {
                        canceled.push(trip.tripId);
                    }
                }
            }
            this.newTripsListInitialSelections = true;
            this.tripsWithCancellations = canceled;
        },
        selectAllTrips(selectAll) {
            if (!selectAll) {
                this.tripsWithCancellations = [];
                return;
            }
            let newSelection = [];
            for (const trip of this.tripsListItems) {
                newSelection.push(trip.tripId);
            }
            this.tripsWithCancellations = newSelection;
        },
        tripsWithCancellations(newSelection, oldSelection) {
            if (this.newTripsListInitialSelections) {
                this.newTripsListInitialSelections = false;
                return;
            }
            for (const newTripId of newSelection) {
                let alreadySelected = false;
                for (const oldTripId of oldSelection) {
                    if (oldTripId == newTripId) {
                        alreadySelected = true;
                        break;
                    }
                }
                if (!alreadySelected) {
                    this.$store.commit('trafficDeviations/putTripCancellationToAdd', newTripId);
                    this.$store.commit('trafficDeviations/deleteTripCancellationToRemove', newTripId);
                    this.$store.commit('trafficDeviations/updateTripCancellationTimestamp');
                }
            }
            for (const oldTripId of oldSelection) {
                let stillSelected = false;
                for (const newTripId of newSelection) {
                    if (oldTripId == newTripId) {
                        stillSelected = true;
                        break;
                    }
                }
                if (!stillSelected) {
                    this.$store.commit('trafficDeviations/putTripCancellationToRemove', oldTripId);
                    this.$store.commit('trafficDeviations/deleteTripCancellationToAdd', oldTripId);
                    this.$store.commit('trafficDeviations/updateTripCancellationTimestamp');
                }
            }
        }
    },
    methods: {
        getTimeFromTimestamp(timestamp) {
            let time = moment.parseZone(timestamp);
            if (time.isValid())
                return time.format('HH:mm');

            return '';
        },
        onSelectTrip(value) {
            if (value[0]) {
                this.$store.commit('trafficDeviations/updateSelectedTripId', value[0].tripId);
            }
        },
        autoSelectTrip(tripsList) {
            if (tripsList.length == 1) {
                this.$refs.tripstable.selectRow(0);
            }
        },
        isAllCancellationsRemoved(trip) {
            if (!Array.isArray(trip.passings))
                return false;

            let allRemoved = true;
            for (const passing of trip.passings) {
                if (isPassingCanceled(passing) &&
                        !this.$store.state.trafficDeviations.cancellationsToRemove.hasOwnProperty(getPassingKey(passing))) {
                    allRemoved = false;
                    break;
                }
            }
            return allRemoved;
        },
        isCancellationAdded(trip) {
            if (!Array.isArray(trip.passings)) {
                console.log('Not an array?!');
                return false;
            }

            for (const passing of trip.passings) {
                if (this.$store.state.trafficDeviations.cancellationsToAdd.hasOwnProperty(getPassingKey(passing))) {
                    return true;
                }
            }
            return false;
        }
    }
}
</script>